import React from "react";
import { Box } from "@mui/material";
import Header from "../shared/header";
import SetPasswordForm from "../shared/forms/set-password";

/**
 * Set Password page component that allows users to set their initial password after email verification.
 * The page displays a centered layout with a header and the set password form.
 * 
 * @component
 * @returns {JSX.Element} A centered box containing the set password UI
 * 
 * @example
 * ```tsx
 * <SetPasswordPage />
 * ```
 */
const SetPasswordPage = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="flex-start" // changed from center to prevent header cutoff on small screens
      minHeight="100vh" // changed from height to allow growth if content is taller than viewport
        sx={{ overflowY: "auto" }} // moved into sx
    >
      <Box width="100%" m="50px">
        <Box textAlign="center">
        </Box>
        <SetPasswordForm />
      </Box>
    </Box>
  );
};

export default SetPasswordPage;